import React, { useContext, useEffect, useRef, useState } from "react";
import {
  getAPIRequest,
  putPostRequest,
} from "utilFunctions/Axios/AxiosRequestConfiguration";
import { uploadDrsAttachments } from "Pages/DRS/Utils/uploadDrsAttachments";
import {
  BASE_URL,
  Doubts_GetAllDoubts,
  GET_CARD_ANALYTICS,
  cdnUrl,
} from "utilFunctions/Constants/urlConstants";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import { DRS_DASHBOARD_ACCESS_ROLE } from "utilFunctions/Constants/Constants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import { INITIAL_STATUS } from "Pages/DRS/DRSFilter/DRSAdvancedFilters";
import { Form, message } from "antd";
import dayjs from "dayjs";
import { useNavigate, useLocation } from "react-router-dom";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
export const initial_pagination_values = {
  pageSize: 10,
  total: 10,
  pageSizeOptions: ["10", "50", "100"],
  showSizeChanger: true,
  current: 1,
  sortField: "branchOrRegionName",
  sortOrder: "ASC",
};
const currentMonthYear = () => dayjs().format("YYYY-MM");
const getMasterLabel = (options: any[] | undefined, id: any) =>
  id == null
    ? ""
    : options?.find(
        (option: any) => String(option.id ?? option.value) === String(id)
      )?.label ?? "";

export const INITIAL_DRS_DASHBOARD_STATE: any = {
  yearMonthStart: currentMonthYear(),
  yearMonthEnd: currentMonthYear(),
  subjectIds: undefined,
};
export const DRS_INITIAL_DATE = {
  startDate: dayjs().subtract(30, "day").startOf("day").format("YYYY/MM/DD"),
  endDate: dayjs().endOf("day").format("YYYY/MM/DD"),
};
export const DRSContext = React.createContext<any>(null);
export const DRSContextProvider = (props: any) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const userInfo = React.useContext<any>(UserInfoContext);
  const [DRSData, setDRSData] = React.useState<any>([]);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [DSRFilters, setDSRFilters] = React.useState<any>({
    statuses: INITIAL_STATUS,
    dateRange: DRS_INITIAL_DATE,
  });
  const [drsDashboardFilters, setDrsDashboardFilters] = useState(
    INITIAL_DRS_DASHBOARD_STATE
  );
  const [individualFacultyFilters, setIndividualFacultyFilters] = useState(
    INITIAL_DRS_DASHBOARD_STATE
  );
  const [initialIndividualFacultyFilters, setInitialIndividualFacultyFilters] =
    useState(INITIAL_DRS_DASHBOARD_STATE);
  const [selectedQuestion, setSelectedQuestion] = React.useState<any>({});
  const [updatedQuestion, setUpdatedQuestion] = React.useState<any>({});
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isSubmitDone, setIsSubmitDone] = useState<boolean>(false);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [isUploadError, setIsUploadError] = useState<boolean>(false);
  const [aiSolutionUsed, setAiSolutionUsed] = useState<boolean>(false);
  const [pagination, setPagination] = useState(initial_pagination_values);
  const [paginationDRSFilter, setPaginationDRSFilter] = useState(
    initial_pagination_values
  );
  const [questionPayload, setQuestionPayload] = useState({
    id: null,
    subjectId: null,
    streamId: null,
    answerText: null,
    isAnswerFinal: true,
    contentRecordIds: null as Awaited<
      ReturnType<typeof uploadDrsAttachments>
    > | null,
  });
  const [drsDashboard, setDrsDashboard] = useState({});
  const [drsAllSubjects, setDrsAllSubjects] = useState<any[]>([]);
  const { masters } = useMasterContext();
  const [skipReason, setSkipReasons] = useState([]);
  const [isSkipped, setIsSkipped] = useState<boolean>(false);
  const [isFiltersApplied, setIsFiltersApplied] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [clientRequestId, setClientRequestId] = useState<string | null>(null);

  useEffect(() => {
    if (selectedQuestion?.id) {
      const hashSeed = `${selectedQuestion.id}_${Date.now()}_${Math.random()}`;
      let hash = 0;
      for (let i = 0; i < hashSeed.length; i++) {
        const char = hashSeed.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      setClientRequestId(Math.abs(hash).toString(16));
    } else {
      setClientRequestId(null);
    }
  }, [selectedQuestion?.id]);

  const prevFiltersRef = useRef();
  const trackedResolveDoubtRef = useRef<any>(null);
  const location = useLocation();
  const { pathname } = location;
  const isQuestionSessionStarted = pathname.includes("DRS/question");
  const {
    makeRequest: fetchDRSDashboard,
    loading: isFetchDRSDashboardLoading,
  } = useGetApi(
    (res: any) => {
      const { data } = res || {};
      setDrsDashboard(data);
      setPaginationDRSFilter({
        ...paginationDRSFilter,
        total: res?.totalCount || 0,
      });
    },
    (err: any) => {
      const { response } = err || {};
      const { data } = response || {};
      const { error = "Failed to generate", message } = data || {};
      setPaginationDRSFilter({
        ...paginationDRSFilter,
        total: 0,
      });
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error || message,
      });
    }
  );
  const {
    makeRequest: fetchQuestionDetail,
    loading: isQuestionDetailLoading,
    responseData: questionDetail,
  } = useGetApi(
    (res: any) => {
      const { data } = res;
      setSelectedQuestion(data);
      setUpdatedQuestion({});
    },
    (error: any) => {
      const { response } = error || {};
      const { data } = response || {};
      const { message = "Failed to generate" } = data || {};
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: message,
      });
      navigate("/admin/DRS");
    }
  );
  useEffect(() => {
    const data = questionDetail?.data;
    if (!data?.id || trackedResolveDoubtRef.current === questionDetail) return;

    const streamName = getMasterLabel(masters?.streams, data.streamId);
    const subjectName = getMasterLabel(masters?.subjects, data.subjectId);
    // Master data can arrive after the question response. Wait for its labels.
    if (
      (data.streamId != null && !streamName) ||
      (data.subjectId != null && !subjectName)
    ) {
      return;
    }

    trackedResolveDoubtRef.current = questionDetail;
    const dateRangeText = DSRFilters?.dateRange
      ? `${DSRFilters.dateRange.startDate}, ${DSRFilters.dateRange.endDate}`
      : "";
    pushToDataLayerForGTM({
      event: "ag_drs_resolve_doubt",
      DOUBT_ID: data.id,
      BATCH_ID: data.batchId ?? "",
      DATE_RANGE: dateRangeText,
      STREAM: streamName,
      SUBJECT: subjectName,
      STATUS: data.status ?? "",
      DRS_RATING: data.studentRating ?? "",
    });
  }, [
    questionDetail,
    masters?.streams,
    masters?.subjects,
    DSRFilters?.dateRange,
  ]);
  const {
    makeRequest: getCardAnalytics,
    loading: isCardAnalytic,
    responseData: cardAnalytic,
  } = useGetApi(
    () => {
      console.log();
    },
    (error: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error["message"] || "Failed to generate",
      });
    }
  );
  const {
    makeRequest: getSolveByMe,
    loading: isSolvedByMe,
    responseData: solveByMe,
  } = useGetApi(
    () => {
      console.log();
    },
    (error: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error["message"] || "Failed to generate",
      });
    }
  );
  const {
    makeRequest: fetchViewQuestion,
    loading: isViewQuestion,
    responseData: viewQuestion,
  } = useGetApi(
    (res: any) => {
      const { data } = res || {};
      setUpdatedQuestion(data);
      // Also update selectedQuestion to reflect the latest status after submission
      setSelectedQuestion(data);
    },
    (error: any) => {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: error["message"] || "Failed to generate",
      });
    }
  );

  useEffect(() => {
    if (
      DRS_DASHBOARD_ACCESS_ROLE.includes(userInfo?.fexRole || "") &&
      masters?.subjects?.length > 0
    ) {
      setDrsAllSubjects(masters.subjects);
    }
  }, [masters?.subjects, userInfo?.fexRole]);

  const createPresignedURL = (url: string, data: any, files: any[]) => {
    try {
      setIsUploading(true);
      setIsUploadError(false);
      putPostRequest({
        url: url,
        success: async (res: any) => {
          const { data: dataRes } = res || {};
          const { data = [] } = dataRes || {};
          try {
            const contentIds = await uploadDrsAttachments(files, data, cdnUrl);
            message.success("Files uploaded successfully!");
            setQuestionPayload((previous) => ({
              ...previous,
              contentRecordIds: contentIds,
            }));
            setIsUploading(false);
          } catch (uploadError: any) {
            message.error(
              uploadError.message || "Failed to upload some files to S3."
            );
            setIsUploading(false);
            setIsUploadError(true);
          }
        },
        failure: (err: any) => {
          console.log(err);
          message.error("Failed to generate presigned URLs.");
          setIsUploading(false);
          setIsUploadError(true);
        },
        body: data,
        method: "Post",
      } as any);
    } catch (error) {
      message.error("Failed to upload files.");
      setIsUploading(false);
      setIsUploadError(true);
    }
  };
  useEffect(() => {
    const isIndividualFaculty = pathname.includes("DRS/faculty/");
    const isMyBucket =
      pathname.endsWith("/admin/DRS") || pathname.endsWith("/admin/DRS/");

    if (!isIndividualFaculty && !isMyBucket) {
      return;
    }

    if (isIndividualFaculty && !DSRFilters?.useIndividualFacQuesAPI) {
      return;
    }

    const filtersHaveChanged =
      prevFiltersRef.current &&
      JSON.stringify(DSRFilters) !== JSON.stringify(prevFiltersRef.current);

    // Store current filters in ref for next render
    prevFiltersRef.current = DSRFilters;

    if (filtersHaveChanged && pagination.current !== 1) {
      // If filters changed, reset to page 1 and return.
      // The effect will run again with the correct page.
      setPagination((p) => ({ ...p, current: 1 }));
      return;
    }

    // Fetch main DRS data
    let drsDataUrl = BASE_URL + Doubts_GetAllDoubts;
    const deletedFields = [];
    if (DSRFilters?.useIndividualFacQuesAPI) {
      drsDataUrl = BASE_URL + "drs-dashboard/faculty/questions";
      deletedFields.push("useIndividualFacQuesAPI");
    }
    fetchDRSData(drsDataUrl, deletedFields);

    // Fetch card analytics data
    const { id: userId } = userInfo || {};
    const analyticsUrl = BASE_URL + GET_CARD_ANALYTICS;
    const newURL = getUrlWithFilters(analyticsUrl, ["statuses"]);

    if (isMyBucket) {
      getCardAnalytics(newURL);

      if (userId) {
        getSolveByMe(`${newURL}&facultyId=${userId}`);
      }
    } else if (isIndividualFaculty) {
      const facultyId = DSRFilters?.facultyId;
      if (facultyId) {
        const finalURL = `${newURL}&facultyId=${facultyId}`;
        getCardAnalytics(finalURL);
        getSolveByMe(finalURL);
      }
    }
  }, [
    DSRFilters,
    pagination.current,
    pagination.pageSize,
    pathname,
    userInfo?.id,
  ]);
  const getUrlWithFilters = (url: string, deletedFields?: any) => {
    const limit = pagination.pageSize;
    const offset = (pagination.current - 1) * limit;
    let newURL = url + `?offset=${offset}&limit=${limit}`;

    setIsLoading(true);
    const filters2: any = [];
    const formFilters = { ...DSRFilters };
    const values = formFilters.dateRange;
    const { startDate: sd, endDate: eD } = values || {};
    const { startDate, endDate } = formFilters;
    formFilters["startDate"] = startDate ? startDate : sd?.replace(/\//g, "-");
    formFilters["endDate"] = endDate ? endDate : eD?.replace(/\//g, "-");

    delete formFilters["dateRange"];
    delete formFilters["useIndividualFacQuesAPI"];
    (deletedFields || [])?.forEach((field: any) => {
      delete formFilters[field];
    });
    const formValues: any = removeEmptyFields(formFilters);
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters2.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }
    if (Array.isArray(filters2) && filters2.length > 0) {
      newURL = newURL + "&" + filters2.join("&");
    }
    return newURL;
  };
  const fetchDRSData = async (url: string, deletedFields?: any) => {
    const newURL = getUrlWithFilters(url, deletedFields);
    getAPIRequest({
      url: newURL,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes, totalCount } = response || {};
        setPagination({
          ...pagination,
          total: totalCount,
        });
        setDRSData(dataRes);
        setIsLoading(false);
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
    setIsLoading(false);
  };
  const getDRSSkipReasons = async (url: string) => {
    getAPIRequest({
      url: url,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes } = response || {};
        const { configValue } = dataRes || {};
        const arr = configValue.split(",");
        setSkipReasons(
          arr.map((ele: any) => ({
            label: ele,
            value: ele,
          }))
        );
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
    setIsLoading(false);
  };
  const value = {
    DRSData,
    setDRSData,
    selectedQuestion,
    setSelectedQuestion,
    fetchDRSData,
    isLoading,
    setDSRFilters,
    DSRFilters,
    isQuestionSessionStarted,
    pagination,
    questionDetail,
    isQuestionDetailLoading,
    getCardAnalytics,
    isCardAnalytic,
    cardAnalytic,
    getSolveByMe,
    solveByMe,
    isSolvedByMe,
    setPagination,
    setQuestionPayload,
    createPresignedURL,
    questionPayload,
    fetchQuestionDetail,
    setIsSubmitDone,
    isSubmitDone,
    isUploading,
    isUploadError,
    fetchViewQuestion,
    isViewQuestion,
    viewQuestion,
    updatedQuestion,
    setUpdatedQuestion,
    form,
    fetchDRSDashboard,
    isFetchDRSDashboardLoading,
    drsDashboard,
    drsDashboardFilters,
    setDrsDashboardFilters,
    paginationDRSFilter,
    setPaginationDRSFilter,
    setAiSolutionUsed,
    aiSolutionUsed,
    individualFacultyFilters,
    setIndividualFacultyFilters,
    initialIndividualFacultyFilters,
    setInitialIndividualFacultyFilters,
    getDRSSkipReasons,
    skipReason,
    isSkipped,
    setIsSkipped,
    isFiltersApplied,
    setIsFiltersApplied,
    isSubmitting,
    setIsSubmitting,
    clientRequestId,
    setClientRequestId,
    drsAllSubjects,
  };
  return (
    <DRSContext.Provider value={value}>{props.children}</DRSContext.Provider>
  );
};
export const useDRSContext = () => {
  const context = React.useContext(DRSContext);
  if (!context) {
    throw new Error("useDRSContext must be used within a DRSContextProvider");
  }
  return context;
};
